import Accountant from "./Accountant";
import Footer from "../Footer/Footer.js";

const AccountantWebPage = () => {
  return (
    <div
      style={{
        minHeight: "88vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Accountant />
      <Footer />
    </div>
  );
};

export default AccountantWebPage;
